import {
  CandyCrushDailyBonusBadge,
  DailyBonusBadge,
  EDailyBonusBadgeInternalViewModel,
  JunesJourneyDailyBonusBadge
} from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const defaultDailyBonusBadge: BlockMetadata = {
  id: EDailyBonusBadgeInternalViewModel.DEFAULT,
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/daily-bonus-badge/default-daily-bonus-badge.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: DailyBonusBadge
};

const defaultJunesJourney: BlockMetadata = {
  id: EDailyBonusBadgeInternalViewModel.JUNES_JOURNEY,
  version: '1.0.0',
  name: 'Junes Journey',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/daily-bonus-badge/junes-journey-daily-badge.png'
  ],
  theme: EThemes.JUNES_JOURNEY,
  component: JunesJourneyDailyBonusBadge
};

const defaultCandyCrush: BlockMetadata = {
  id: EDailyBonusBadgeInternalViewModel.CANDY_CRUSH,
  version: '1.0.0',
  name: 'Candy Crush',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/daily-bonus-badge/king-daily-badge.png'
  ],
  theme: EThemes.KING,
  component: CandyCrushDailyBonusBadge
};

export const dailyBonusBadgesDesigns = {
  defaultDailyBonusBadge,
  defaultJunesJourney,
  defaultCandyCrush
};
